import {StyleSheet} from 'react-native';
import {vs} from '@/Utils/Dimensions';

const styles = StyleSheet.create({
  container: {
    margin: 2,
    justifyContent: 'center',
    height: vs(150),
    flex: 1,
    borderRadius: 8,
  },
  content: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  riveContainer: {
    height: 60,
    width: 60,
    marginTop: 1,
  },
  text: {
    margin: 10,
  },
});

export default styles;
